var map = {
	"./AboutUs/AboutUs": 7523,
	"./AboutUs/AboutUs.js": 7523,
	"./Events/Events": 1837,
	"./Events/Events.jsx": 1837,
	"./EventsSection": 8572,
	"./EventsSection/": 8572,
	"./EventsSection/Card": 9494,
	"./EventsSection/Card.jsx": 9494,
	"./EventsSection/CompCard": 6120,
	"./EventsSection/CompCard.jsx": 6120,
	"./EventsSection/data": 7436,
	"./EventsSection/data.js": 7436,
	"./EventsSection/index": 8572,
	"./EventsSection/index.jsx": 8572,
	"./Faq/Faq": 3211,
	"./Faq/Faq.js": 3211,
	"./Faq/FaqItem": 163,
	"./Faq/FaqItem.jsx": 163,
	"./Faq/faqdata": 6074,
	"./Faq/faqdata.js": 6074,
	"./Footer/Footer": 4930,
	"./Footer/Footer.js": 4930,
	"./Hamburger": 4152,
	"./Hamburger/": 4152,
	"./Hamburger/index": 4152,
	"./Hamburger/index.jsx": 4152,
	"./Home/Home": 7807,
	"./Home/Home.js": 7807,
	"./JudgesSection": 8874,
	"./JudgesSection/": 8874,
	"./JudgesSection/JudgeCard": 9560,
	"./JudgesSection/JudgeCard.jsx": 9560,
	"./JudgesSection/index": 8874,
	"./JudgesSection/index.jsx": 8874,
	"./MentorTalkPage": 7870,
	"./MentorTalkPage.jsx": 7870,
	"./MentorTalks": 1227,
	"./MentorTalks/": 1227,
	"./MentorTalks/MentorTalk": 265,
	"./MentorTalks/MentorTalk.jsx": 265,
	"./MentorTalks/images/main/ExpertTalks-Nupur.png": 9050,
	"./MentorTalks/images/main/ExpertTalks-Sanjay.png": 6618,
	"./MentorTalks/images/main/ExpertTalks-Shreya.png": 9478,
	"./MentorTalks/images/main/ExpertTalks-Vishal.png": 4331,
	"./MentorTalks/images/thumbnails/ExpertTalks-Nupur.png": 2221,
	"./MentorTalks/images/thumbnails/ExpertTalks-Sanjay.png": 5787,
	"./MentorTalks/images/thumbnails/ExpertTalks-Shreya.png": 7826,
	"./MentorTalks/images/thumbnails/ExpertTalks-Vishal.png": 34,
	"./MentorTalks/index": 1227,
	"./MentorTalks/index.jsx": 1227,
	"./MentorsSection": 850,
	"./MentorsSection/": 850,
	"./MentorsSection/index": 850,
	"./MentorsSection/index.jsx": 850,
	"./Navbar/Navbar": 8434,
	"./Navbar/Navbar.jsx": 8434,
	"./PrizesSection": 6630,
	"./PrizesSection/": 6630,
	"./PrizesSection/Card": 6785,
	"./PrizesSection/Card.jsx": 6785,
	"./PrizesSection/index": 6630,
	"./PrizesSection/index.jsx": 6630,
	"./Separator": 9631,
	"./Separator.jsx": 9631,
	"./Separator2": 4708,
	"./Separator2.jsx": 4708,
	"./Sponsors/SponsorCard": 4008,
	"./Sponsors/SponsorCard/": 4008,
	"./Sponsors/SponsorCard/index": 4008,
	"./Sponsors/SponsorCard/index.jsx": 4008,
	"./Sponsors/Sponsors": 139,
	"./Sponsors/Sponsors.jsx": 139,
	"./TeamSection": 2241,
	"./TeamSection/": 2241,
	"./TeamSection/index": 2241,
	"./TeamSection/index.jsx": 2241,
	"./TeamSection/team-images/AakashMaurya_OutreachCoreTeam.jpg": 5456,
	"./TeamSection/team-images/AayushPatel_CommunityEngagement.jpg": 9381,
	"./TeamSection/team-images/AshutoshJaiswal_Logistics.jpg": 7432,
	"./TeamSection/team-images/ChitraTrivedi_OutreachCoreTeam.jpg": 2383,
	"./TeamSection/team-images/DevPatel_OutReach.jpg": 3621,
	"./TeamSection/team-images/DhruvikGondaliya_ContentWriting.jpg": 3667,
	"./TeamSection/team-images/DhruvkumarPatel_ContentWriting.jpg": 7900,
	"./TeamSection/team-images/DhyeyPatel_graphicteam.jpg": 7341,
	"./TeamSection/team-images/Diya shah_Community Engagement.jpg": 7610,
	"./TeamSection/team-images/HastiBhalodiya_DesignTeam.jpg": 6909,
	"./TeamSection/team-images/JAIVIN GAJERA_WEB DEVELOPMENT_.jpg": 7555,
	"./TeamSection/team-images/JainShreyasSunilkumar_CommunityEngagement.jpg": 5289,
	"./TeamSection/team-images/Janviprajapati_logistic.jpg": 5932,
	"./TeamSection/team-images/Karina Vaishali Mehta_CommunityEngagement.jpg": 7810,
	"./TeamSection/team-images/KeyurChaniyara_WebDev.jpg": 1821,
	"./TeamSection/team-images/KhushbooKolhe_ContentWriting.jpg": 9514,
	"./TeamSection/team-images/Korat Dishant _ design.jpg": 3760,
	"./TeamSection/team-images/KrishitaViroja_Logistics.jpg": 5405,
	"./TeamSection/team-images/KuldeepSolanki_webdev.png": 4792,
	"./TeamSection/team-images/MadhveshKanjariya_OutreachCoreTeam.jpg": 4937,
	"./TeamSection/team-images/ManavRijwani_Logistics.jpg": 9858,
	"./TeamSection/team-images/NandiniGohel_WebDev.jpg": 2419,
	"./TeamSection/team-images/Nikhil Parikh_Outreach.jpg": 8980,
	"./TeamSection/team-images/NiravPanchal_Logistics.jpg": 6880,
	"./TeamSection/team-images/OmdevsinhZala_Design.jpg": 4127,
	"./TeamSection/team-images/ParthVora_CommunityEngagement.jpg": 4186,
	"./TeamSection/team-images/PatelNijal_CommunityEngagement.jpg": 7894,
	"./TeamSection/team-images/PrachiJethava_WebDev.jpg": 5831,
	"./TeamSection/team-images/PragatKholia_ContentWriting.jpg": 3719,
	"./TeamSection/team-images/PranshuPancholi_Logistics.jpg": 8102,
	"./TeamSection/team-images/PushtiShah_Logistics.jpg": 4323,
	"./TeamSection/team-images/Rajput Harshilsinh_Web development.jpg": 1198,
	"./TeamSection/team-images/RavalKrupesh_ContentWriting.jpg": 5744,
	"./TeamSection/team-images/RayirthJaiswal_Design.jpg": 6810,
	"./TeamSection/team-images/RiyaSonara_ContentWriting.jpg": 4434,
	"./TeamSection/team-images/Sarthakjadav_CommunityEngagement.jpg": 672,
	"./TeamSection/team-images/ShyamSagothia_Logistics.jpg": 4386,
	"./TeamSection/team-images/Siddhant Gandhi_Community Engagement.jpg": 8891,
	"./TeamSection/team-images/VaghelaDhruvi_ContentWriting.jpg": 1279,
	"./TeamSection/team-images/VaidehiKayastha_LogisticsTeam.jpg": 8846,
	"./TeamSection/team-images/VandanGohil_Design.jpg": 7635,
	"./TeamSection/team-images/YagniShah_ContentWriting.jpg": 573,
	"./TeamSection/team-images/Yash Hindocha_webDev.jpg": 7325,
	"./TeamSection/team-images/YatreeLadani_WebDev.jpg": 4443,
	"./TeamSection/team-raw-images/AakashMaurya_OutreachCoreTeam.jpeg": 5367,
	"./TeamSection/team-raw-images/AayushPatel_CommunityEngagement.jpg": 6621,
	"./TeamSection/team-raw-images/AdityaThakar_Logistics.jpg": 1129,
	"./TeamSection/team-raw-images/AshutoshJaiswal_Logistics.jpg": 8130,
	"./TeamSection/team-raw-images/ChintanPatel_CommunityEngagement.jpg": 8018,
	"./TeamSection/team-raw-images/ChitraTrivedi_OutreachCoreTeam.jpg": 6962,
	"./TeamSection/team-raw-images/DevPatel_OutReach.PNG": 9024,
	"./TeamSection/team-raw-images/DhruvikGondaliya_ContentWriting.jpg": 8702,
	"./TeamSection/team-raw-images/DhruvkumarPatel_ContentWriting.jpg": 2520,
	"./TeamSection/team-raw-images/DhyeyPatel_graphicteam.jpg": 7660,
	"./TeamSection/team-raw-images/Diya shah_Community Engagement.jpg": 6645,
	"./TeamSection/team-raw-images/Gajjar Viral Kirankumar_CommunityEngagement .jpeg": 6108,
	"./TeamSection/team-raw-images/HarshilModh_WebDev.jpg": 8810,
	"./TeamSection/team-raw-images/HastiBhalodiya_DesignTeam.jpg": 9230,
	"./TeamSection/team-raw-images/JAIVIN GAJERA_WEB DEVELOPMENT .jpeg": 9547,
	"./TeamSection/team-raw-images/JAIVIN GAJERA_WEB DEVELOPMENT_.jpg": 3875,
	"./TeamSection/team-raw-images/JainShreyasSunilkumar_CommunityEngagement.jpg": 1656,
	"./TeamSection/team-raw-images/Janviprajapati_logistic.jpg": 7229,
	"./TeamSection/team-raw-images/JayShah_outreach.jpeg": 2604,
	"./TeamSection/team-raw-images/Karina Vaishali Mehta_CommunityEngagement.PNG": 6668,
	"./TeamSection/team-raw-images/KeyurChaniyara_WebDev.jpg": 8583,
	"./TeamSection/team-raw-images/KhushbooKolhe_ContentWriting.jpg": 4486,
	"./TeamSection/team-raw-images/Korat Dishant _ design.jpg": 8399,
	"./TeamSection/team-raw-images/KrishitaViroja_Logistics.jpeg": 8505,
	"./TeamSection/team-raw-images/KrishnaPatel_CommunityEngagement.heic": 8416,
	"./TeamSection/team-raw-images/KrishnaPatel_CommunityEngagement.jpg": 6000,
	"./TeamSection/team-raw-images/KuldeepSolanki_webdev.png": 8788,
	"./TeamSection/team-raw-images/MadhveshKanjariya_OutreachCoreTeam.jpg": 3144,
	"./TeamSection/team-raw-images/ManavRijwani_Logistics.jpeg": 9488,
	"./TeamSection/team-raw-images/MehtaJainam_OutreachCoreTeam.jpeg": 1010,
	"./TeamSection/team-raw-images/NandiniGohel_WebDev.jpeg": 6967,
	"./TeamSection/team-raw-images/Nikhil Parikh_Outreach.JPG": 4462,
	"./TeamSection/team-raw-images/NiravPanchal_Logistics.jpg": 6447,
	"./TeamSection/team-raw-images/Nischay Agrawal_Outreach.JPG": 7198,
	"./TeamSection/team-raw-images/OmdevsinhZala_Design.jpg": 9567,
	"./TeamSection/team-raw-images/OmdevsinhZala_Design.webp": 5994,
	"./TeamSection/team-raw-images/Oveskhan Pathan_outreach.jpg": 6351,
	"./TeamSection/team-raw-images/ParthVora_CommunityEngagement.jpg": 1488,
	"./TeamSection/team-raw-images/PatelNijal_CommunityEngagement.jpg": 1682,
	"./TeamSection/team-raw-images/PrachiJethava_WebDev.jpeg": 8736,
	"./TeamSection/team-raw-images/PragatKholia_ContentWriting.jpg": 883,
	"./TeamSection/team-raw-images/PranshuPancholi_Logistics.jpg": 1438,
	"./TeamSection/team-raw-images/PushtiShah_Logistics.jpg": 2117,
	"./TeamSection/team-raw-images/Rajput Harshilsinh_Web development.jpg": 9507,
	"./TeamSection/team-raw-images/RavalKrupesh_ContentWriting.jpg": 8558,
	"./TeamSection/team-raw-images/RayirthJaiswal_Design.jpg": 8715,
	"./TeamSection/team-raw-images/RiyaSonara_ContentWriting.jpg": 9807,
	"./TeamSection/team-raw-images/SanjayKriplani_Logistics.jpg": 4941,
	"./TeamSection/team-raw-images/Sarthakjadav_CommunityEngagement.jpg": 7282,
	"./TeamSection/team-raw-images/ShlokPatel_logistics.jpeg": 5307,
	"./TeamSection/team-raw-images/Shlok_logistics.jpg": 7879,
	"./TeamSection/team-raw-images/ShyamSagothia_Logistics.jpg": 8664,
	"./TeamSection/team-raw-images/Siddhant Gandhi_Community Engagement.jpg": 5950,
	"./TeamSection/team-raw-images/VaghelaDhruvi_ContentWriting.jpg": 5735,
	"./TeamSection/team-raw-images/VaidehiKayastha_LogisticsTeam.jpg": 6861,
	"./TeamSection/team-raw-images/VandanGohil_Design.jpg": 1429,
	"./TeamSection/team-raw-images/Vatsal Mavani.jpeg": 3364,
	"./TeamSection/team-raw-images/Ved Prajapati.jpg": 7855,
	"./TeamSection/team-raw-images/Vikas_Pal_CommunityEngagement.HEIC": 3589,
	"./TeamSection/team-raw-images/Vikas_Pal_CommunityEngagement.jpg": 2324,
	"./TeamSection/team-raw-images/VrushikMehta_Design.jpg": 2140,
	"./TeamSection/team-raw-images/VyomChaudhari_Outreach.jpeg": 9978,
	"./TeamSection/team-raw-images/YagniShah_ContentWriting.jpg": 9606,
	"./TeamSection/team-raw-images/Yash Hindocha_webDev.jpeg": 2288,
	"./TeamSection/team-raw-images/YatreeLadani_WebDev.jpg": 865,
	"./TimeLine/TimeLine": 9812,
	"./TimeLine/TimeLine.jsx": 9812,
	"./WorkshopPage": 2421,
	"./WorkshopPage.jsx": 2421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8207;